import {
  TranslateLoader,
  TranslateModule,
  TranslateService
} from '@ngx-translate/core';
import {
  HttpBackend,
  withInterceptors,
  provideHttpClient
} from '@angular/common/http';
import player from 'lottie-web';
import { LOCALE_ID, NgModule } from '@angular/core';
import { AppComponent } from './app.component';
import { provideLottieOptions } from 'ngx-lottie';
import { AuthService } from './services/auth.service';
import { AppRoutingModule } from './app-routing.module';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { PaginatorI18n } from './utilities/translation-pagiantor';
import { SplitioService } from './services/splitIO/splitio.service';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DefaultHttpInterceptor } from './interceptors/default-http.interceptor';
import { NotificationsModule } from './components/shared/notifications/notifications.module';
import { NavigationHistoryModule } from './components/shared/navigation-history/navigation-history.module';
import { AccountDeactivationModalComponent } from './components/shared/account-deactivation-modal/account-deactivation-modal.component';
import { registerLocaleData } from '@angular/common';
import localsEsUs from '@angular/common/locales/es-US';
import localsEsCo from '@angular/common/locales/es-CO';
import { provideTkTheme } from '@tekus/design-system/core/types';

export function HttpLoaderFactory(
  _httpBackend: HttpBackend
): MultiTranslateHttpLoader {
  return new MultiTranslateHttpLoader(_httpBackend, [
    '/assets/i18n/shared/',
    '/assets/i18n/kiosks/',
    '/assets/i18n/screens/',
    '/assets/i18n/messaging/'
  ]);
}

export function registerLocaleDynamic() {
  let localID = navigator?.language;
  if (
    !localID ||
    (localID !== 'es-CO' &&
      localID !== 'es-US' &&
      localID !== 'es-ES' &&
      localID !== 'en-US')
  ) {
    localID = 'es-CO';
  } else if (localID === 'es-ES' || localID === 'en-US') {
    localID = 'es-US';
  }
  registerLocaleData(localsEsUs, 'es-US');
  registerLocaleData(localsEsCo, 'es-CO');

  return localID;
}

@NgModule({
  declarations: [AppComponent, AccountDeactivationModalComponent],
  imports: [
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        deps: [HttpBackend],
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory
      },
      fallbackLang: 'es'
    }),
    AppRoutingModule,
    NotificationsModule,
    BrowserAnimationsModule,
    NavigationHistoryModule
  ],
  providers: [
    AuthService,
    SplitioService,
    provideLottieOptions({
      player: () => player
    }),
    provideCharts(withDefaultRegisterables()),
    {
      provide: 'googleTagManagerId',
      useValue: environment.googleTagManagerId
    },
    {
      provide: MatPaginatorIntl,
      deps: [TranslateService],
      useFactory: (translateService: TranslateService) =>
        new PaginatorI18n(translateService).getPaginatorIntl()
    },
    {
      provide: LOCALE_ID,
      useFactory: registerLocaleDynamic
    },
    provideHttpClient(withInterceptors([DefaultHttpInterceptor])),
    provideTkTheme()
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
